import { useQuery } from '@tanstack/react-query';

import { standbyServicesQuery } from '@/api/standby/standbyServicesQuery';

import type { UseStandbyServicesQueryOptions } from './types';

export const useStandbyServicesQuery = (
  shopId: string,
  requestedBarberId: string | null,
  options?: UseStandbyServicesQueryOptions,
) =>
  useQuery({
    ...standbyServicesQuery(shopId, requestedBarberId),
    ...options,
    // A caller's `enabled` must never re-open the factory's required-shopId
    // guard — matches useStandbyStylistsQuery/useStandbyPublicShopQuery.
    enabled: !!shopId && (options?.enabled ?? true),
  });
